import React, { useState } from "react";
import style from "./index.module.scss";
import BatchPicker from "../../main/components/MainMobile/components/BatchPicker";
import { Button, Icon, Spin } from "antd";
import { getNetCourseList, getNoWeekTimeCourseList } from "../../../API";
import useStorage from "../../../Utils/useStorage";
import Config from "../../../config";
import useRequest from "../../../Utils/useRequest";

import courseImg from "../PC/components/List/images/course.png";
import courseImg2 from "../PC/components/List/images/course2.png";
import courseImg3 from "../PC/components/List/images/course3.png";
import courseImg4 from "../PC/components/List/images/course4.png";
import courseImg5 from "../PC/components/List/images/course5.png";
import courseImg6 from "../PC/components/List/images/course6.png";
import addIcon from "./images/addIcon.png";
import CustomEmpty from "components/CustomEmpty";
import AddModal from "./components/AddModal";
import { Link } from "react-router-dom";
import icon1 from "./images/1.png";
import icon2 from "./images/2.png";
import icon4 from "./images/4.png";
import { Badge } from "antd-mobile";
import { evaluationStatus } from "../../../API/evaluate";

function getImgUrl(index: number) {
    const ImgArr = [
        courseImg,
        courseImg2,
        courseImg3,
        courseImg4,
        courseImg5,
        courseImg6
    ];
    const num = index % ImgArr.length;
    return ImgArr[num];
}

function CourseListMobile() {
    const [open, setOpen] = useState(false);
    const [batch] = useStorage(
        "batch",
        localStorage.getItem("batch") || Config.DefaultBatch
    );
    const [data, { loading }, refreshNet] = useRequest(
        () => getNetCourseList(batch),
        {},
        [batch]
    );
    const [dataNoWeekTime, { loading: dataNoWeekTimeLoading }, refreshNoWeek] =
        useRequest(() => getNoWeekTimeCourseList(batch), {}, [batch]);

    function refreshData() {
        refreshNet();
        refreshNoWeek();
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <BatchPicker
                    showResetBtn={false}
                    onResetWeek={() => {}}
                    showSchedule
                />
            </div>

            <div className={style.btnContainer}>
                <Button
                    type="primary"
                    block
                    className={style.addBtn}
                    onClick={() => setOpen(true)}>
                    <img src={addIcon} alt="" />
                    加入课程
                </Button>
            </div>

            <div className={style.body}>
                <Spin spinning={loading || dataNoWeekTimeLoading}>
                    {dataNoWeekTime &&
                        dataNoWeekTime.map((item, index) => (
                            <div className={style.item} key={index}>
                                <div className={style.info}>
                                    <div className={style.left}>
                                        <img src={getImgUrl(index)} alt="" />
                                    </div>
                                    <div className={style.right}>
                                        <div className={style.title}>
                                            {item.courseName}
                                        </div>
                                        <div className={style.info}>
                                            教师：{item.teacherName}
                                        </div>
                                    </div>
                                </div>

                                <div className={style.footer}>
                                    {item?.evaluationStatus &&
                                        item.evaluationStatus !==
                                            evaluationStatus.EvaluationIsNull && (
                                            <Badge
                                                dot={
                                                    item.evaluationStatus ===
                                                    evaluationStatus.NotEvaluated
                                                }>
                                                <Link
                                                    to={`/evaluate/${item?.evaluationId}/${item?.multiEvaluationFlag}`}
                                                    className={
                                                        style.chapterBtn
                                                    }>
                                                    <img src={icon1} alt="" />
                                                    评教
                                                </Link>
                                            </Badge>
                                        )}

                                    <Link
                                        to={`/course/detail/${item.courseNo}/${item.courseSeq}/${item.weekTimeId}/report`}
                                        className={style.chapterBtn}>
                                        <Icon type="stock" />
                                        报告
                                    </Link>

                                    <Link
                                        to={`/course/chapters/${item.courseNo}/${item.courseSeq}`}
                                        className={style.chapterBtn}>
                                        <img src={icon2} alt="" />
                                        章节
                                    </Link>
                                    <Link
                                        to={`/course/score/detail/${
                                            item.courseNo
                                        }/${item.courseSeq}/${
                                            item.weekTimeId
                                        }?courseName=${encodeURIComponent(
                                            item.courseName
                                        )}`}
                                        className={style.chapterBtn}>
                                        <img src={icon4} alt="" />
                                        成绩
                                    </Link>
                                    {/*{item.isOpen === "1" && (*/}
                                    {/*    <a*/}
                                    {/*        target="_blank"*/}
                                    {/*        className={style.liveAndScreen}*/}
                                    {/*        href={`/student/goToPlay?channelId=${*/}
                                    {/*            item.channelId*/}
                                    {/*        }&userId=${localStorage.getItem(*/}
                                    {/*            "user"*/}
                                    {/*        )}&chapterCode=&versionCode=${*/}
                                    {/*            item.lmsCourseNo*/}
                                    {/*        }`}*/}
                                    {/*        rel="noreferrer">*/}
                                    {/*        <img src={icon3} alt="" />*/}
                                    {/*        去上课*/}
                                    {/*    </a>*/}
                                    {/*)}*/}
                                </div>
                            </div>
                        ))}
                    {data &&
                        data.map((item, index) => (
                            <div className={style.item} key={index}>
                                <div className={style.left}>
                                    <img
                                        src={getImgUrl(
                                            (dataNoWeekTime
                                                ? dataNoWeekTime.length
                                                : 0) + index
                                        )}
                                        alt=""
                                    />
                                </div>
                                <div className={style.right}>
                                    <div className={style.title}>
                                        {item.courseName}
                                    </div>
                                    <div className={style.info}>
                                        教师：{item.teacherName}
                                    </div>
                                </div>

                                <div className={style.footer}>
                                    <Link
                                        to={`/course/chapters/${
                                            item.courseNo
                                        }/${
                                            item.courseSeq
                                        }?courseName=${encodeURIComponent(
                                            item.courseName
                                        )}`}
                                        className={style.chapterBtn}>
                                        查看章节
                                    </Link>
                                    <Link
                                        to={`/course/score/detail/${
                                            item.courseNo
                                        }/${item.courseSeq}/${
                                            item.weekTimeId
                                        }/detail?courseName=${encodeURIComponent(
                                            item.courseName
                                        )}`}
                                        className={style.chapterBtn}>
                                        成绩
                                    </Link>
                                </div>
                            </div>
                        ))}
                    {(!data || data.length === 0) &&
                        (!dataNoWeekTime || dataNoWeekTime.length === 0) && (
                            <CustomEmpty className={style.customEmpty} />
                        )}
                </Spin>
            </div>

            {open && (
                <AddModal
                    onCancel={() => setOpen(false)}
                    refreshData={refreshData}
                />
            )}
        </div>
    );
}

CourseListMobile.defaultProps = {
    planCourse: false
};

export default CourseListMobile;
